import React from "react";
import "./FeatureCard.scss";

export default function FeatureCard({ children, className = "" , ...rest }) {
	return (
		<div className={`feature-card-wrapper ${className}`} {...rest}>
			<div className="feature-card">
				<div className="solid-border"></div>
				<div className="gradient-border"></div>
				<div className="feature-card-inner">{children}</div>
			</div>
		</div>
	);
}
